import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { mutationAddLabelTemplate } from "Apollo";
import { ShowNotice } from "Store";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import InputRowRaw from "module-common/InputRow";

export default graphql(mutationAddLabelTemplate)(
  class AddLabelModal extends Component {
    static propTypes = {
      labelType: PropTypes.string,
      refetch: PropTypes.func,
      onCancel: PropTypes.func,
      onConfirm: PropTypes.func
    };
    state = {
      name: "",
      displayName: "",
      loading: false
    };

    render() {
      const { onCancel } = this.props;
      const { name, displayName, loading } = this.state;
      return (
        <Modal>
          <Wrapper>
            <Text>Add Label</Text>
            <form
              onSubmit={event => {
                this.onConfirm();
                event.preventDefault();
              }}
            >
              <InputRow
                labelWidth={100}
                label="Name"
                value={name}
                onChange={text => {
                  this.setState({ name: text });
                }}
              />
              <InputRow
                labelWidth={100}
                label="Display Name"
                value={displayName}
                onChange={text => {
                  this.setState({ displayName: text });
                }}
              />
              <SubmitButton type="submit" />
            </form>
            <Buttons>
              <Button
                width={100}
                onClick={onCancel}
                color="gray"
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                width={100}
                onClick={this.onConfirm}
                loading={loading}
                disabled={loading}
              >
                Add
              </Button>
            </Buttons>
          </Wrapper>
        </Modal>
      );
    }

    onConfirm = async () => {
      const { labelType, onConfirm, mutate, refetch } = this.props;
      const { name, displayName } = this.state;

      if (onConfirm) {
        if (name && displayName) {
          this.setState({ loading: true });
          try {
            await mutate({
              variables: {
                name: name,
                displayName: displayName,
                labelType: labelType,
                order: 0,
                color: "000000"
              }
            });
            if (refetch) refetch();
            onConfirm();
            ShowNotice("label-template-add-success");
          } catch (error) {
            ShowNotice("label-template-add-error");
          }
          this.setState({ loading: false });
        } else {
          ShowNotice("label-template-incomplete-field-error");
        }
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  align-items: center;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 10px;
`;
const Buttons = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;
const SubmitButton = styled.button`
  display: none;
`;
const InputRow = styled(InputRowRaw)`
  margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/label-panel/AddLabelModalWithMutation.js